<template>
    <modal :name="propsName" width="100%" height="100%" :max-width="800" :max-height="700" :adaptive="true"
        styles="background: rgba(255, 255, 255, .85); border-radius: 10px;" :click-to-close="false">
        <div class="modal modal-confirm">
            <div class="modal-content">
                <a href="javascript:void(0);" class="bt-modal-close bt" data-iziModal-close=".modal-detail-1">
                    <img :src="`@/${getIcoModalClosePath()}`" alt="" v-on:click="hide"/>
                </a>
                <p class="order-modal-header">今回のご注文分の請求先を選択してください</p><br>
                <p>※代理店を通じてのご請求を希望される場合は、お客様ご自身で代理店様へ注文のご依頼をお願いいたします。</p><br>
                <p v-if="billingList.length == 0" class="billing-user-select-modal-area-text">請求ユーザーが存在しません</p>
                <div>
                    <div class="select-billing" v-if="billingList.length > 0">
                        <div class="select-billing-main" v-for="billing in billingList" :value="billing.code" :key="billing.code">
                            <input type="radio" :value="billing.code" v-model="selectedBilling" @change="callShowOrderSequence()"/>
                            <div class="select-billing-item">
                                <label>請求先名：{{ billing.name }}</label>
                                <label>住所：{{ billing.address }}</label>
                                <label>電話番号：{{ billing.number }}</label>
                            </div>
                        </div>                        
                    </div>                
                </div>                                
            </div>
            <!--/.modal-content-->
        </div>
        <!--/.modal-->
    </modal>
</template>
<script>
export default {
    name: 'SelectBillingUserModal',
    props: {
        propsName: String, // ヘッダーとサイドバーとバナーで重複表示を避けるため
        propsBillings: Array,
        propsSelectedBilling: Object
    },
    watch: {
        propsBillings: function (value) {
            var list = [];            
            if (value) {
                value.forEach(function (item) {
                    list.push(item);                
                });            
            }            
            this.billingList = list;            
        }
    },
    data () {
        return  {
            billingList: [],
            onlyBilling: false // true : 請求先選択のみ(注文履歴からの再注文時に使用) / false : 商品選択も行う
        }
    },
    computed: {                
        selectedBilling: {
            get () {                                
                return this.propsSelectedBilling ? this.propsSelectedBilling.code : "";
            },
            set (selectesBillingCode) {                                
                var selectedBilling = null;
                for (let i = 0; i < this.billingList.length; i++) {
                    if (selectesBillingCode == this.billingList[i].code) {                        
                        selectedBilling = this.billingList[i];
                        break;
                    }
                }                                        
                this.$emit("selectedBilling", selectedBilling);
            }
        },        
    },
    methods: {
        show() {            
            this.disablePageScroll();
            this.onlyBilling = false;
            this.$modal.show(this.propsName);
        },
        hide() {
            this.enablePageScroll();
            this.$modal.hide(this.propsName);
        },
        callShowOrderSequence () {
            this.enablePageScroll();
            if (this.onlyBilling) {
                this.callToReOrder();                
            } else {
                this.callGoOrderForm();
            }
        },
        callGoOrderForm () {             
            this.$emit("callGoOrderForm");                        
        },        
        /**
         * 注文履歴画面から請求ユーザーを選択する場合
         */
        showSelectBillingUserOnly() {
            this.disablePageScroll();
            this.onlyBilling = true;
            this.$modal.show(this.propsName);
        },
        /**
         * 請求ユーザーを選択後、再注文へ進む
         */
        callToReOrder() {
            this.$emit("callToReOrder");
        }
    },
}
</script>
  


// WEBPACK FOOTER //
// src/components/SelectBillingUserModal.vue